import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'
import '@enterprise-ui/canvas-ui-css-datepicker'
import { HelveticaForTarget } from '@enterprise-ui/component-font'
import { AuthProvider } from '@praxis/component-auth'
import { AnalyticsProvider } from '@praxis/component-analytics'
import { UncaughtError } from './globalComponents/UncaughtError'
import { VendorProvider } from './globalState/Vendor/index'
import { isTargetOrPOLDomain } from './services/auth'
import './globalStyles/customStyles.scss'
import { Main } from './views/Main'
import apiConfig from './globalConfig/apiConfig'
import { SavedViewProvider } from './globalState/SavedViews'
import { routes } from './globalConfig/routes'
import { itemCommonUtilis } from 'item-component'
import { CostSearchProvider } from './globalState/CostSearch'
import { CostChangeInsightsGlobalProvider } from './globalState/CostChangeInsights'
import { NotificationsProvider } from './globalState/ManageNotifications'

const App = () => {
  const eventManagerConfiguration = {
    ...apiConfig.analytics,
    apiKey: apiConfig.apiKey,
  }

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />} errorElement={<UncaughtError />}>
        {routes}
      </Route>,
    ),
    { basename: itemCommonUtilis.findAppPath() },
  )

  function Layout() {
    return (
      <>
        <HelveticaForTarget variants={['n4', 'n5', 'n7']} />
        <AuthProvider
          {...apiConfig.auth}
          loginRedirect={`${window.location.origin}${itemCommonUtilis.findAppPath()}`}
          logoutRedirect={`${window.location.origin}${itemCommonUtilis.findAppPath()}`}
          shouldSendHeaders={isTargetOrPOLDomain}
        >
          <AnalyticsProvider
            eventManagerConfiguration={eventManagerConfiguration}
            trackLocations
          >
            <VendorProvider>
              <CostSearchProvider>
                <CostChangeInsightsGlobalProvider>
                  <SavedViewProvider>
                    <NotificationsProvider>
                      <Main />
                    </NotificationsProvider>
                  </SavedViewProvider>
                </CostChangeInsightsGlobalProvider>
              </CostSearchProvider>
            </VendorProvider>
          </AnalyticsProvider>
        </AuthProvider>
      </>
    )
  }

  return <RouterProvider router={router} />
}

export default App
